function reducer(state = [], action) {
    switch (action.type) {
        case 'IS_CART_OPEN/SET':
            return action.isCartOpen;
        default:
            return state;
    }
}

export default reducer;
